import { SkeletonDotsProps } from './SkeletonDots.type'
import { DotsWrapper } from './SkeletonDots.styles'

const SkeletonDots = ({
  size = 6,
  durationSeconds = 0.75,
  ...divProps
}: SkeletonDotsProps) => (
  <DotsWrapper size={size} durationSeconds={durationSeconds} {...divProps}>
    <div />
    <div />
    <div />
  </DotsWrapper>
)

export default SkeletonDots
